"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.wrapPageElement = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = require("react-dom");

var _constants = require("./constants");

const filterTypes = Object.keys(_constants.types);
filterTypes.unshift('none');

function Filter({
  toggleKey
}) {
  const [filter, setFilter] = (0, _react.useState)(filterTypes[0]);
  const [isActive, setIsActive] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    const onKeyDown = e => {
      e.key === toggleKey && setIsActive(true);
      isActive && setFilter(filter => filterTypes[e.key] || filter);
    };

    const onKeyUp = e => {
      e.key === toggleKey && setIsActive(false);
    };

    window.addEventListener('keydown', onKeyDown);
    window.addEventListener('keyup', onKeyUp);
    return () => {
      window.removeEventListener('keydown', onKeyDown);
      window.removeEventListener('keyup', onKeyUp);
    };
  }, [isActive, toggleKey]);
  (0, _react.useEffect)(() => {
    document.documentElement.setAttribute(_constants.dataAttribute, filter);
  }, [filter]);
  return isActive && (0, _reactDom.createPortal)(_react.default.createElement("div", {
    style: {
      padding: '0.5rem 1rem',
      textTransform: 'capitalize'
    }
  }, filter), document.getElementById(_constants.controlId));
}

Filter.propTypes = {
  toggleKey: _propTypes.default.string.isRequired
};

const wrapPageElement = ({
  element
}, {
  toggleKey = 'p'
} = {}) => _react.default.createElement(_react.default.Fragment, null, element, _react.default.createElement(Filter, {
  toggleKey: toggleKey.toLowerCase()
}));

exports.wrapPageElement = wrapPageElement;